module.exports = __webpack_public_path__ + "img/search-photo-3.fd12e6da.png";